export const timeTrackingDateRanges = ['allDateRanges', 'thisMonth', 'lastMonth', 'last90Days', 'thisYear', 'lastYear'];
export const timeTrackingHoursStatuses = ['allStatuses', 'addHours', 'pending', 'approved'];
